import api from "../axios";

export type InviteStatus = "pending" | "in-progress" | "completed" | "expired";

export interface InviteSummary {
  id: number;
  uuid: string;
  createdAt: string;
  status: InviteStatus;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  monthlyRentAmount: number;
  leaseStartDate: string | null;
  leaseEndDate: string | null;
  hasPet: boolean;
  coverageAmount: number | null;
  coverageMultiplier: number | null;
  quoteId: number | null;
  /** Admin-granted credit against this invite's first payment. */
  creditAmount?: number | null;
  /** Set once the credit has been spent; it does not apply again. */
  creditAppliedAt?: string | null;
  unit: {
    id: number;
    uuid: string;
    name: string;
    property: {
      id: number;
      uuid: string;
      name: string;
      address: string;
      state: string;
    } | null;
  } | null;
  account: {
    id: number;
    uuid: string;
    companyName: string;
  } | null;
}

export function getMyInvites() {
  return api.get<InviteSummary[]>("/invites");
}

export function getInvite(uuid: string) {
  return api.get<InviteSummary>(`/invites/${uuid}`);
}

export type SDAPurchaseStatus =
  | "pending"
  | "processing"
  | "succeeded"
  | "failed"
  | "cancelled";

export interface SDAPurchaseResult {
  transactionUuid: string;
  status: SDAPurchaseStatus;
  amount: number;
  paymentIntentId: string;
  /** Set once the backend has materialized a Policy (sync-succeeded path). */
  policyUuid?: string;
  policyName?: string;
  renewalDate?: string;
  error?: string;
}

export function purchaseSdaInvite(
  uuid: string,
  paymentMethodId: number,
  /**
   * Set to true when the user has accepted the ACH/Nacha authorization
   * on a bank-account payment. Required server-side for bank PMs;
   * ignored for cards. The user's IP + User-Agent are read from the
   * request itself, not passed by the client.
   */
  mandateAccepted?: boolean,
) {
  return api.post<SDAPurchaseResult>(`/invites/${uuid}/purchase`, {
    paymentMethodId,
    ...(mandateAccepted ? { mandateAccepted: true } : {}),
  });
}
